import { useState, useEffect, useRef } from "react";
import { SpsAbstractControl } from "./SpsAbstractControl.interface";
import { SpsValidationStatus } from "../SpsValidators";

export function useServerSideValidation(
    formControl: SpsAbstractControl<any>,
    initialState: SpsValidationStatus = null
) {
    const [status, setStatus] = useState(initialState);
    const validatiorFn = useRef(() => null);

    useEffect(() => {
        const newFn = () => status;
        const index = formControl.validators.indexOf(validatiorFn.current);
        if (index === -1) {
            formControl.validators.push(newFn);
        } else {
            formControl.validators[index] = newFn;
        }
        formControl.update();
        validatiorFn.current = newFn;
    }, [status]);

    return [status, setStatus];
}
